import { render, staticRenderFns } from "./servicer.vue?vue&type=template&id=d209fda8&"
import script from "./servicer.vue?vue&type=script&lang=js&"
export * from "./servicer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports